import { useNavigate } from 'react-router-dom';
import { getPopularComics, getNewestComics } from '@/mocks/comics';
import { useState } from 'react';

export default function PopularSection() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<'popular' | 'newest'>('popular');
  const popularComics = getPopularComics(8);
  const newestComics = getNewestComics(8);
  const displayComics = activeTab === 'popular' ? popularComics : newestComics;

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            漫画排行榜
          </h2>
          <div className="flex items-center bg-background-100 rounded-full p-1">
            <button
              onClick={() => setActiveTab('popular')}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'popular'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-950'
              }`}
            >
              <i className="ri-fire-line mr-1.5"></i>人气榜
            </button>
            <button
              onClick={() => setActiveTab('newest')}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                activeTab === 'newest'
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-950'
              }`}
            >
              <i className="ri-timer-line mr-1.5"></i>最新更新
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
          {displayComics.map((comic, index) => (
            <article
              key={comic.id}
              className="group cursor-pointer"
              onClick={() => navigate(`/comic/${comic.slug}`)}
            >
              <div className="relative overflow-hidden rounded-xl mb-3 aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 非麻瓜漫画`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2 w-7 h-7 flex items-center justify-center bg-background-950/60 backdrop-blur-sm rounded-lg">
                  <span className="text-background-50 text-xs font-bold">{index + 1}</span>
                </div>
                {activeTab === 'newest' && comic.chapters[0] && (
                  <div className="absolute bottom-2 right-2 px-2 py-1 bg-primary-500 text-background-50 text-xs rounded-md">
                    {comic.chapters[0].title}
                  </div>
                )}
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-sm group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{comic.categoryName} · {comic.author}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}